import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/disclaimer/client/DisclaimerClient.tsx");
